'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Selected = exports.Deselected = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Deselected = exports.Deselected = function Deselected(props) {
  var width = props.width,
      color = props.color;


  return _react2.default.createElement(
    'svg',
    { width: width, height: width, viewBox: '0 0 24 24' },
    _react2.default.createElement(
      'defs',
      null,
      _react2.default.createElement('path', {
        id: 'radio-default-a',
        d: 'M12,21.8181818 C17.4224321,21.8181818 21.8181818,17.4224321 21.8181818,12 C21.8181818,6.57756791 17.4224321,2.18181818 12,2.18181818 C6.57756791,2.18181818 2.18181818,6.57756791 2.18181818,12 C2.18181818,17.4224321 6.57756791,21.8181818 12,21.8181818 Z M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z'
      })
    ),
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('use', { fill: color, xlinkHref: '#radio-default-a' })
    )
  );
};

Deselected.propTypes = {
  width: _propTypes2.default.string,
  color: _propTypes2.default.string
};

Deselected.defaultProps = {
  width: '16px',
  color: _colors.cobalt.base
};

var Selected = exports.Selected = function Selected(props) {
  var width = props.width,
      color = props.color;


  return _react2.default.createElement(
    'svg',
    { width: width, height: width, viewBox: '0 0 24 24' },
    _react2.default.createElement(
      'defs',
      null,
      _react2.default.createElement('path', {
        id: 'selected-a',
        d: 'M21.8181818,12 C21.8181818,6.57756791 17.4224321,2.18181818 12,2.18181818 C6.57756791,2.18181818 2.18181818,6.57756791 2.18181818,12 C2.18181818,17.4224321 6.57756791,21.8181818 12,21.8181818 C17.4224321,21.8181818 21.8181818,17.4224321 21.8181818,12 Z M0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 Z M12,17.4545455 C15.0124623,17.4545455 17.4545455,15.0124623 17.4545455,12 C17.4545455,8.98753773 15.0124623,6.54545455 12,6.54545455 C8.98753773,6.54545455 6.54545455,8.98753773 6.54545455,12 C6.54545455,15.0124623 8.98753773,17.4545455 12,17.4545455 Z'
      })
    ),
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('use', { fill: color, xlinkHref: '#selected-a' })
    )
  );
};

Selected.propTypes = {
  width: _propTypes2.default.string,
  color: _propTypes2.default.string
};

Selected.defaultProps = {
  width: '16px',
  color: _colors.teal.base
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress/react-components/lib/shapes/radio.js
// module id = 219
// module chunks = 0